import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { deleteUser } from 'redux/modules/duck-admin';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';

import colors from 'utils/colors';
import { baseFont } from 'utils/fonts';

const Cancel = styled.button`
  color: #ffffff;
  font-family: ${baseFont};
  font-size: 12px;
  letter-spacing: 0.46px;
  line-height: 15px;
  text-align: center;

  box-sizing: border-box;
  height: 22px;
  width: 75.3px;
  border: 1px solid #ffffff;
  border-radius: 2px;
  background: ${colors.action2};
  cursor: pointer;
  margin: 5px 0;

  &:hover {
    color: ${colors.action2};
    background: ${colors.white};
    border-color: ${colors.action2};
  }
`;

class CancelButton extends Component {
  render() {
    const { _user, history } = this.props;
    return (
      <Cancel
        onClick={() => {
          this.props.deleteUser(_user, history);
        }}
      >
        Yes
      </Cancel>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      deleteUser,
    },
    dispatch
  );
}

export default connect(
  null,
  mapDispatchToProps
)(CancelButton);
